import { Comment, CommentProps } from 'antd'

export { Comment }
export type { CommentProps }
